import axios from "axios";
const authToken = localStorage.getItem('authToken');
const lang=localStorage.getItem('lang');
console.log(lang);
export function useAuth() {
  const isLoggedIn = () => {
    return !!localStorage.getItem('authToken');
  };

  const setToken = (token) => {
    localStorage.setItem('authToken', token);
    authToken = token;
  };

  const clearToken = () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem(localStorage.getItem('userId'));
    // authToken = "";
  };

  return { isLoggedIn, setToken, clearToken };
}
console.log(lang);

axios.defaults.headers.common["Accept-Language"] = lang;
var domain = "https://aqaar.code7x.com/api";
axios.defaults.baseURL = domain;
axios.defaults.timeout = 10000; // 20 seconds timeout for all requests
if (domain == "https://aqaar.code7x.com/api") {
  axios.defaults.token =`Bearer ${authToken}`
} else {
  axios.defaults.token;
}